import { Navigate, useSearchParams } from "react-router-dom";
import { useGovernanceSettings } from "../../../utils/icGovernance";
import GovernanceItemDetail from "../Governance/ItemDetail";
import GovernanceWeeklyReport from "../Governance/WeeklyReport";
import { SupportLoading } from "./SupportHub";
import TicketDetail from "./TicketDetail";
import { SUPPORT_BASE, TICKET_VIEW_URL, isTicketView } from "./supportView";

/**
 * /dashboard/support/:id (:id = IC_Ticket display id, e.g. TD-ISS-12 or
 * TD-CR-4): the governance item page when the server says governance is on
 * (admins; works for every kind), else the Support ticket page. A settings
 * load error also falls back to the ticket page. `?view=tickets` forces the
 * ticket page for anyone.
 */
const SupportItemPage = () => {
  const { settings, loading } = useGovernanceSettings();
  const [searchParams] = useSearchParams();
  if (isTicketView(searchParams)) return <TicketDetail />;
  if (loading) return <SupportLoading />;
  return settings.enabled ? <GovernanceItemDetail /> : <TicketDetail />;
};

/** /dashboard/support/weekly-status/:reportId — workbook only; everyone else goes back to /support. */
export const SupportReportPage = () => {
  const { settings, loading } = useGovernanceSettings();
  const [searchParams] = useSearchParams();
  const ticketView = isTicketView(searchParams);
  if (!ticketView && loading) return <SupportLoading />;
  if (ticketView || !settings.enabled) {
    return <Navigate to={ticketView ? TICKET_VIEW_URL : SUPPORT_BASE} replace />;
  }
  return <GovernanceWeeklyReport />;
};

export default SupportItemPage;
